import React from 'react';
import {
    SP_SKIP, extractResponseData, SmartStyles, SmartHeader, SmartSection, NoRecordsCard, RawResponseButton
} from './_SmartFieldRenderer';

// Known field classification for Drug License
const GROUPS = {
    license:  { title: 'LICENSE DETAILS', icon: 'pi-id-card',     keys: ['license_no', 'license_number', 'license_type', 'license_category', 'status', 'license_status', 'firm_name', 'owner_name', 'applicant_name', 'state_code', 'state_name', 'state'] },
    validity: { title: 'VALIDITY',        icon: 'pi-calendar',    keys: ['issued_date', 'issued_on', 'valid_from', 'valid_upto', 'expiry_date'] },
    contact:  { title: 'CONTACT',         icon: 'pi-phone',       keys: ['email', 'mobile', 'phone', 'contact_number'] },
    address:  { title: 'ADDRESS',         icon: 'pi-map-marker',  keys: ['address', 'premises_address', 'city', 'pincode', 'district'] },
    products: { title: 'APPROVED DRUGS',  icon: 'pi-list',        keys: ['products', 'product_categories', 'approved_drugs', 'drugs'] },
};

const HIGHLIGHT = ['license_no', 'license_number'];

const DrugLicenseOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) {
        return <NoRecordsCard subtitle="No data available" />;
    }

    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No drug license records found for the provided details. Please verify and try again." />;
    }

    const d = responseData;

    // Split data into known groups + leftover (unknown) fields
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach(k => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }

    const knownKeys = new Set(Object.values(GROUPS).flatMap(g => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            <SmartStyles />
            <SmartHeader
                title="Drug License Verification Report"
                icon="pi-heart"
                remainingBalance={remainingBalance}
                shouldHideCredits={shouldHideCredits}
            />
            <div className="horizontal-report-card">
                {Object.entries(GROUPS).map(([groupName, meta]) => (
                    grouped[groupName]
                        ? <SmartSection key={groupName} title={meta.title} icon={meta.icon} data={grouped[groupName]} highlightKeys={HIGHLIGHT} />
                        : null
                ))}

                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="OTHER DETAILS" icon="pi-info-circle" data={leftover} />
                )}

                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default DrugLicenseOutputComponent;
